import { useUserStore } from "~/stores/userstore";
import { type ToastItem, useToastStore } from "~/stores/ui/toaststore";

export default defineNuxtRouteMiddleware((_unused_to, _unused_from) => {
  console.debug("userIsAdmin middleware");
  const userStore = useUserStore();

  if (!userStore.isStoreAdmin) {
    const toastStore = useToastStore();
    toastStore.addToast({
      id: self.crypto.randomUUID(),
      title: `Not Store Admin`,
      body: `You are not an admin user.`,
      appendToast: false,
      position: "top-center",
      variant: "danger",
      solid: true,
    } as ToastItem);
    return navigateTo("/");
  }
});
